export const DECIMALS_DISPLAYED_MAX_LENGTH = 11;

export const GOLDBERG_TESTNET_EXPLORER = 'https://avail-goldberg.subscan.io/';
export const MAINNET_EXPLORER = 'https://avail.subscan.io/';
export const TURING_TESTNET_EXPLORER = 'https://avail-turing.subscan.io/';
export const SNAPS_DOC_URL = 'https://docs.metamask.io/guide/snaps.html';

export const INPUT_MAX_LENGTH = 100;

export const POPOVER_DURATION = 3000;

export const TRANSACTIONS_REFRESH_FREQUENCY = 60000;

export const TOKEN_BALANCE_REFRESH_FREQUENCY = 60000;

export const TIMEOUT_DURATION = 10000;
